
function Footer(props) {
	return (
		<div className="footer">

            <div className="description">
                <h2 className="footer__text">dotBEATS</h2>
                <p >Music has the ability to bring people together. It has the power to transcend language barriers, to cross social and cultural boundaries, and to connect people in a way that nothing else can. No matter what your taste in music, there is always a song that can bring people together. Whether it is a shared love of a particular artist or genre, or simply a catchy tune that gets everyone moving. So next time you are looking for a way to bond with someone, try sharing a song. You might just find that music is the perfect way to connect with someone on a deeper level.</p>
            </div>

            <div className="contributors">
                <h2>Contributors</h2>
                <a href="https://github.com/vfuertez">Vincent</a><br/>
                <a href="https://github.com/rickycary">Richard</a><br/>
                <a href="https://github.com/Camacho-A">Angelica</a><br/>
                <a href="https://github.com/rockcat96">Michelle</a>
            </div>
		</div>
	)
}

export default Footer
